import Vue from "vue";
import Vuex from "vuex";
import { $api, arrToObj, setProp, deleteProp } from "bh-mod";
Vue.use(Vuex);

export default {
	state: {
		searchFilter: "",
		selectedTab: "Sent",
		loadingPage: false,
		broadcasts: {},
		getStarted: false,
		allSettings: {},
		messagingServices: [],
		activePhoneNumbers: [],
		activePhoneNumbersLoaded: false,
		multipleImages: false,
		walletDetails: {
			balance: 0,
		},
		rechargeOptions: [],
		phoneNumberCharge: 5,
		aiAgents: [],
		users: [],
		refreshBroadcast: false,
	},
	mutations: {
		REFRESH_BROADCASTS(state, value) {
			state.refreshBroadcast = value;
		},
		SMS_TYPE(state, data) {
			state.selectedTab = data.value;
		},
		UPDATE_SEARCH(state, data) {
			state.searchFilter = data;
		},
		LOAD_PAGE: (state, status = !state.loadingPage) =>
			(state.loadingPage = status),
		SET_APPDATA(state, data) {
			if (!data) data = {};
			const { messagingServices = [] } = data;
			state.messagingServices = messagingServices
		},
		SET_SETTINGS(state, data) {
			let temp = data;

			temp.userApp = data.userApp || { options: { seenIntro: false, sms: [] } };

			temp.app = data.app || { options: {} };
			temp.app.options = temp.app.options || {};
			temp.app.options.leadScorePoints = temp.app.options.leadScorePoints || { SMSClick: 4 };
			temp.app.options.unsubscribeMessage = data.app.options.unsubscribeMessage ?? '';

			state.allSettings = temp;
		},
		UPDATE_APP_OPTIONS_SETTINGS: (state, data) => {
			state.allSettings.app.options = { ...state.allSettings.app.options, ...data };
		},
		GET_STARTED: (state) => {
			state.getStarted = true;
		},
		UPDATE_BROADCAST(state, broadcasts) {
			state.broadcasts = arrToObj(broadcasts);
		},
		SET_ACTIVE_PHONE_NUMBERS: (state, data) => {
			state.activePhoneNumbers = data
			state.activePhoneNumbersLoaded = true
		},
		REMOVE_ACTIVE_PHONE_NUMBER: (state, id) => {
			const index = state.activePhoneNumbers.findIndex(
				(item) => item.id === id
			);
			if (index > -1) state.activePhoneNumbers.splice(index, 1);
		},
		SET_PROP: (state, { where, what, del = false, update = false }) => {
			if (del) return deleteProp(state, where);
			if (typeof where === "string") where = where.split(".");
			state.newStoreTime = Date.now();
			setProp(state, where, what);
		},

		SET_MULTIPLE_IMAGES(state, data) {
			state.multipleImages = data
		},

		SET_WALLET_DETAILS: (state, data) => {
			state.walletDetails = {
				...data
			};
		},

		SET_RECHARGE_OPTIONS: (state, data) => {
			state.rechargeOptions = data;
		},

		SET_PHONE_NUMBER_CHARGE: (state, data) => {
			state.phoneNumberCharge = data.convertedAmount || 5;
		},

		SET_AI_AGENTS: (state, data) => {
			state.aiAgents = data;
		},

		SET_USERS(state, data) {
			state.users = data.map(d => d.user) || [];
		},
	},
	actions: {
		SET_APPDATA: ({ commit, dispatch, rootState }, data) => {
			commit("SET_APPDATA", data)
			if (rootState.instance?.currency && rootState.instance?.currency !== 'USD') {
				dispatch('FETCH_PHONE_NUMBER_CHARGE');
			}
			dispatch("FETCH_WALLET_DETAILS");
			dispatch('FETCH_USERS');
		},

		async FETCH_USERS({ commit }) {
			try {
				const { data } = await $api.get(`instances/:instance/users`);
				commit('SET_USERS', data.users)
			} catch (error) {
				console.error('Error occurred while fetching user list', error)
			}
		},

		FETCH_PHONE_NUMBER_CHARGE: async ({ commit }) => {
			try {
				const { data } = await $api.get(`/utils/convert-currency?amount=5&targetCurrency=CAD`);
				commit('SET_PHONE_NUMBER_CHARGE', data)
			} catch (error) {
				console.error(`An error occurred while fetching phone number charge.`, error);
			}
		},

		FETCH_ACTIVE_PHONE_NUMBERS: async ({ commit }) => {
			try {
				const { data } = await $api.get(`/sending-phone-numbers/:instance`);
				commit('SET_ACTIVE_PHONE_NUMBERS', data)
			} catch (error) {
				console.error(`An error occurred while fetching instance phone number.`, error);
			}
		},

		FETCH_WALLET_DETAILS: async ({ commit }) => {
			try {
				const { data } = await $api.get(`/wallets/:instance?type=sms`);
				commit('SET_WALLET_DETAILS', data)
			} catch (error) {
				console.error(`An error occurred while fetching bundle usages.`, error);
			}
		},

		FETCH_RECHARGE_OPTIONS: async ({ commit }, currency) => {
			try {
				const { data } = await $api.get(`/wallets/:instance/recharge-options?currency=${currency}`);
				commit('SET_RECHARGE_OPTIONS', data)
			} catch (error) {
				console.error(`An error occurred while fetching recharge options.`, error);
			}
		},
		FETCH_AI_AGENTS: async ({ commit, rootGetters }) => {
			if (!rootGetters.isAIAdvanceAddOn) return;
			try {
				const { data } = await $api.get(`/ai-agents/:instance?capability_type=call&active=true`);
				commit('SET_AI_AGENTS', data)
			} catch (error) {
				console.error(`An error occurred while fetching AI agents.`, error);
			}
		},
	},
};
